import classNames from "classnames";
import Form, { Field as BaseField } from "rc-field-form";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Card, CardHeader, Col, Row } from "reactstrap";
import Button from "../../../../components/Button";
import Filters from "./Filters";
import { usePreferenceMutation } from "../api/usePreferenceMutation";
import { useCompanyPreferences } from "../hooks/usePreferences";

const options = ["filters"];

function Reports() {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [menu, setMenu] = useState(options[0]);


    const content = useMemo(() => {
        switch (menu) {
            default:
            case "filters":
                return <Filters />;
        }
    }, [menu]);

    const { mutate, isPending } = usePreferenceMutation("company", "reports");
    const config = useCompanyPreferences("reports");

    const onFinish = async (formValues) => {
        await mutate(formValues);
    };

    useEffect(() => {
        form.setFieldsValue(config)
    }, [config, form]);

    return (
        <Card className="h-100">
            <Form form={form} onFinish={onFinish}>
                <CardHeader>
                    <Row>
                        <Col xs="6" className="pl-4 d-flex">
                            <h3 className="mb-0 mr-5">{t("reports")}</h3>
                        </Col>
                        <Col className="text-right" xs="6">
                            <Button
                                className="btn-dark px-3 btn-round btn-icon"
                                size="sm"
                                loading={isPending}
                                disabled={isPending}
                                type="submit"
                            >
                                {t("save")}
                            </Button>
                        </Col>
                    </Row>
                </CardHeader>

                <div className="px-4 py-3">
                    <div className="d-flex justify-content-start flex-wrap gap-2 pb-3">
                        {options.map((option) => <span
                            key={option}
                            className={classNames(menu === option
                                ? "border border-primary text-white bg-primary font-weight-bold rounded px-3 py-2"
                                : "border border-primary text-primary font-weight-bold rounded px-3 py-2",
                                "cursor-pointer"
                            )}
                            onClick={() => setMenu(option)}
                        >
                            {t(option)}
                        </span>)}
                    </div>

                    <div className="pt-4">
                        {content}

                        <BaseField name="filters" />
                    </div>
                </div>
            </Form>
        </Card>
    );
};

export default Reports;
